import React, { useState } from 'react';

const coursesData = [
  {
    id: 1,
    level: 'Diploma',
    levelColor: '#27ae60',
    name: 'General Nursing and Midwifery (GNM)',
    shortName: 'GNM',
    duration: '3 Years',
    icon: '💉',
    description:
      'A foundational program focused on building practical clinical skills, bedside care techniques, community health service, and emergency medical management.',
    eligibility:
      '10+2 in Science, Arts, or Commerce (Science stream preferred) with a minimum of 40–45% aggregate marks from a recognized board.',
    highlights: ['Bedside Care Techniques', 'Community Health Service', 'Emergency Medical Management', 'Clinical Practicum'],
    specializations: [],
  },
  {
    id: 2,
    level: 'Undergraduate Degree',
    levelColor: '#1a3a6b',
    name: 'Bachelor of Science in Nursing (B.Sc. Nursing)',
    shortName: 'B.Sc. Nursing',
    duration: '4 Years (Semester System)',
    icon: '🎓',
    description:
      'An extensive degree designed to develop healthcare leadership, clinical expertise, critical thinking, patient assessment skills, and research capabilities.',
    eligibility:
      '10+2 with Physics, Chemistry, Biology (PCB), and English with a minimum of 45–50% aggregate marks.',
    highlights: ['Healthcare Leadership', 'Clinical Expertise', 'Critical Thinking', 'Research Capabilities', 'Patient Assessment'],
    specializations: [],
  },
  {
    id: 3,
    level: 'Postgraduate Degree',
    levelColor: '#c9a227',
    name: 'Master of Science in Nursing (M.Sc. Nursing)',
    shortName: 'M.Sc. Nursing',
    duration: '2 Years',
    icon: '🏅',
    description:
      'A specialized program for experienced nurses aiming to step into senior clinical roles, academic positions, administrative leadership, and scientific research.',
    eligibility:
      'B.Sc. Nursing or Post Basic B.Sc. Nursing with a minimum of 55% aggregate marks and at least 1 year of clinical or teaching experience.',
    highlights: ['Senior Clinical Roles', 'Academic Positions', 'Administrative Leadership', 'Scientific Research'],
    specializations: [
      'Medical-Surgical Nursing',
      'Obstetrics & Gynecological (OBG) Nursing',
      'Child Health (Pediatric) Nursing',
      'Mental Health (Psychiatric) Nursing',
      'Community Health Nursing',
    ],
  },
];

function Courses() {
  const [active, setActive] = useState(null);

  return (
    <section id="courses" className="courses-section">
      <div className="section-container">
        <div className="section-title-block">
          <h2 className="section-title">
            <span className="title-icon">📚</span> Courses Offered
          </h2>
          <div className="gold-underline"></div>
          <p className="section-subtitle">
            Recognized by INC, RGUHS &amp; Karnataka Nursing Council — Shaping Future Healthcare Leaders
          </p>
        </div>

        <div className="courses-grid-pcn">
          {coursesData.map((course) => (
            <div key={course.id} className={`course-card-pcn ${active === course.id ? 'expanded' : ''}`}>
              <div className="course-level-badge" style={{ background: course.levelColor }}>
                {course.level}
              </div>
              <div className="course-card-header">
                <span className="course-icon-big">{course.icon}</span>
                <div>
                  <h3 className="course-name">{course.name}</h3>
                  <span className="course-duration-tag">⏱ {course.duration}</span>
                </div>
              </div>

              <p className="course-desc-pcn">{course.description}</p>

              <div className="course-info-row">
                <div className="course-info-box">
                  <span className="course-info-label">📝 Eligibility</span>
                  <span className="course-info-val">{course.eligibility}</span>
                </div>
              </div>

              <div className="course-highlights">
                {course.highlights.map((h, i) => (
                  <span key={i} className="highlight-chip">✓ {h}</span>
                ))}
              </div>

              {course.specializations.length > 0 && (
                <div className="course-specializations">
                  <h4>🔬 Specialization Streams</h4>
                  <ul>
                    {course.specializations.map((s, i) => (
                      <li key={i}>➤ {s}</li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="course-card-footer">
                <button
                  className="btn btn-primary"
                  onClick={() => scrollToSection('contact')}
                >
                  Apply Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function scrollToSection(id) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
}

export default Courses;